import { API } from "../api/API";
import { validateResponseStatus } from "../utils";

export const getByTopic = async (token, topicId) => {
  const result = await API()
    .post("academy/resource/getBytopic", { topicId: topicId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const getTime = async (token, courseId) => {
  const result = await API()
    .post("academy/resource/getTime", { courseId: courseId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data[0];
  } else {
    return [];
  }
};
